import {
  BANK_LIST_REQUEST,
  BANK_LIST_SUCCESS,
  BANK_LIST_FAIL,
  BANK_TRANSACTION_LIST_REQUEST,
  BANK_TRANSACTION_LIST_SUCCESS,
  BANK_TRANSACTION_LIST_FAIL,
  BANK_ALL_TRANSACTION_LIST_REQUEST,
  BANK_ALL_TRANSACTION_LIST_SUCCESS,
  BANK_ALL_TRANSACTION_LIST_FAIL,
  BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST,
  BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS,
  BANK_UNALLOCATED_TRANSACTION_LIST_FAIL,
  ITEM_ALLOCATION_LIST_REQUEST,
  ITEM_ALLOCATION_LIST_SUCCESS,
  ITEM_ALLOCATION_LIST_FAIL,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL,
  UNCLEAR_TRANSACTION_REQUEST,
  UNCLEAR_TRANSACTION_SUCCESS,
  UNCLEAR_TRANSACTION_FAIL,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL,
  CREATE_SINGLE_BANK_TRANSACTION_REQUEST,
  CREATE_SINGLE_BANK_TRANSACTION_SUCCESS,
  CREATE_SINGLE_BANK_TRANSACTION_FAIL,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL,
  BANK_UPLOAD_TRANSACTIONS_REQUEST,
  BANK_UPLOAD_TRANSACTIONS_SUCCESS,
  BANK_UPLOAD_TRANSACTIONS_FAIL,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL,
  CREATE_BANK,
  CREATE_BANK_SUCCESS,
  CREATE_BANK_FAIL,
  UPDATE_BANK,
  UPDATE_BANK_SUCCESS,
  UPDATE_BANK_FAIL,
  DELETE_BANK,
  DELETE_BANK_SUCCESS,
  DELETE_BANK_FAIL,
  SYNC_BANK_TRANSACTIONS,
  SYNC_BANK_TRANSACTIONS_SUCCESS,
  SYNC_BANK_TRANSACTIONS_FAIL,
  SYNC_BANK_TRANSACTIONS_RESET,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL,
  GET_BANK_ACCOUNT_STATUS_LIST,
  GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS,
  GET_BANK_ACCOUNT_STATUS_LIST_FAIL,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL,
  BANK_ACCOUNT_PROVIDER_LIST_REQUEST,
  BANK_ACCOUNT_PROVIDER_LIST_SUCCESS,
  BANK_ACCOUNT_PROVIDER_LIST_FAIL,
  GET_BANK_ACCOUNT_STATUS_DATA_REQUEST,
  GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS,
  GET_BANK_ACCOUNT_STATUS_DATA_FAIL,
  CREATE_BANK_ACCOUNT_STATUS_REQUEST,
  CREATE_BANK_ACCOUNT_STATUS_SUCCESS,
  CREATE_BANK_ACCOUNT_STATUS_FAIL,
  UPDATE_BANK_ACCOUNT_STATUS_REQUEST,
  UPDATE_BANK_ACCOUNT_STATUS_SUCCESS,
  UPDATE_BANK_ACCOUNT_STATUS_FAIL,
  DELETE_BANK_ACCOUNT_STATUS_REQUEST,
  DELETE_BANK_ACCOUNT_STATUS_SUCCESS,
  DELETE_BANK_ACCOUNT_STATUS_FAIL,
  BANK_ACCOUNT_FEED_CONNECTION_REQUEST,
  BANK_ACCOUNT_FEED_CONNECTION_SUCCESS,
  BANK_ACCOUNT_FEED_CONNECTION_FAIL,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL,
  BANK_TRANSACTION_IMPORT_REQUEST,
  BANK_TRANSACTION_IMPORT_SUCCESS,
  BANK_TRANSACTION_IMPORT_FAIL,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL,
  BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST,
  BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL,
  BANK_ACCOUNT_FEED_RECONNECTION_REQUEST,
  BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS,
  BANK_ACCOUNT_FEED_RECONNECTION_FAIL,
  CLEARING_DOCUMENT_SEARCH_REQUEST,
  CLEARING_DOCUMENT_SEARCH_SUCCESS,
  CLEARING_DOCUMENT_SEARCH_FAIL,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL,
  BANK_ACCOUNT_ATTACHMENT_SEARCH,
  BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS,
  BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE,
  BANK_ACCOUNT_ATTACHMENT_DELETE,
  BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS,
  BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE,
  BANK_ACCOUNT_STATEMENT_SEARCH,
  BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS,
  BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE,
  BANK_ACCOUNT_STATEMENT_DELETE,
  BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS,
  BANK_ACCOUNT_STATEMENT_DELETE_FAILURE,
} from "./actionType";

// Reducer Actions Bank List

const initialState = {
  bankList: [],
  singleBankTransactionList: [],
  singleBankTransactionListLoading: false,
  allBanksTransactionList: [],
  allBanksTransactionListLoading: false,
  bankUnallocatedTransactionList: [],
  itemAllocationList: [],
  clearedAllocatedTransactionSuccess: [],
  clearedAllocatedTransactionSuccessLoading: false,
  unclearedTransactionSuccess: [],
  singleCustomerSearchAllTransactions: [],
  singleSupplierSearchAllTransactions: [],
  createSingleBankTransactionSuccess: [],
  createSingleBankTransactionSuccessLoading: false,
  singleCustomerTransactionPdfStatement: [],
  bankUploadTransactionsSuccess: [],
  bankUploadTransactionsSuccessLoading: false,
  bankAssignedOnlyTransactionList: [],
  bankAssignTransactionToCustomerSuccess: [],
  bankUnassignTransactionFromCustomerSuccess: [],
  createBankSuccess: [],
  updateBankSuccess: [],
  deleteBankSuccess: [],
  syncBankTransactionsData: {},
  syncBankTransactionsLoading: false,
  CustomerSearchALlTransactionsLoading: false,
  allBankTransactionListLoading: false,
  SingleCustomerTransactionOpenItemsPdfStatement: [],
  SingleCustomerTransactionAllItemsPdfStatement: [],
  bankAccountStatusList: [],
  bankTransactionAllocationDeleteTransactionSuccess: [],
  manualBankTransactionDetails: [],
  updateManualBankTransactionDetailsSuccess: [],
  updateManualBankTransactionDetailsSuccessLoading: false,
  bankAccountProviderList: [],
  bankAccountProviderListLoading: false,
  bankAccountStatusData: [],
  bankAccountStatusDataLoading: false,
  createBankAccountStatusSuccess: [],
  createBankAccountStatusSuccessLoading: false,
  updateBankAccountStatusSuccess: [],
  updateBankAccountStatusSuccessLoading: false,
  deleteBankAccountStatusSuccess: [],
  deleteBankAccountStatusSuccessLoading: false,
  bankAccountFeedConnectionSuccess: [],
  bankAccountFeedConnectionSuccessLoading: false,
  bankAccountFeedMapAccountsSuccess: [],
  bankAccountFeedMapAccountsSuccessLoading: false,
  bankTransactionImportSuccess: [],
  bankTransactionImportSuccessLoading: false,
  bankTransactionAllocationUnclearSuccess: [],
  bankTransactionAllocationUnclearLoading: false,
  bankTransactionAllocationSplitSuccess: [],
  bankTransactionAllocationSplitLoading: false,
  //BANK_ACCOUNT_FEED_RECONNECTION_REQUEST
  bankAccountFeedReconnectionSuccess: [],
  bankAccountFeedReconnectionSuccessLoading: false,

  clearingDocumentSearchLoading: false,
  clearingDocumentSearchSuccess: [],
  clearingDocumentSearchError: null,
  //BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST
  bankTransactionAllocationAutoclearSuccess: [],
  bankTransactionAllocationAutoclearSuccessLoading: false,
  // Bank Account Attachment (bank statements)
  bankAccountAttachmentList: [],
  bankAccountAttachmentListLoading: false,
  bankAccountAttachmentListError: null,
  bankAccountAttachmentDelete: [],
  bankAccountAttachmentDeleteLoading: false,
  bankAccountAttachmentDeleteError: null,
  // Bank Account Statement (bank statements with a period)
  bankAccountStatementList: [],
  bankAccountStatementListLoading: false,
  bankAccountStatementListError: null,
  bankAccountStatementDelete: [],
  bankAccountStatementDeleteLoading: false,
  bankAccountStatementDeleteError: null,
};

const Bank = (state = initialState, action) => {
  switch (action.type) {
    case BANK_LIST_REQUEST:
      return {
        ...state,
      };
    case BANK_LIST_SUCCESS:
      return {
        ...state,
        bankList: action.payload,
      };
    case BANK_LIST_FAIL:
      return {
        ...state,
      };
    case BANK_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        singleBankTransactionList: [],
        singleBankTransactionListLoading: true,
      };
    case BANK_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        singleBankTransactionList: action.payload,
        singleBankTransactionListLoading: false,
      };
    case BANK_TRANSACTION_LIST_FAIL:
      return {
        ...state,
        singleBankTransactionListLoading: false,
      };
    case BANK_ALL_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        allBanksTransactionListLoading: true,
      };
    case BANK_ALL_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        allBanksTransactionListLoading: false,
        allBanksTransactionList: action.payload,
      };
    case BANK_ALL_TRANSACTION_LIST_FAIL:
      return {
        ...state,
        allBanksTransactionListLoading: false,
      };
    case BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
      };
    case BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        bankUnallocatedTransactionList: action.payload,
      };
    case BANK_UNALLOCATED_TRANSACTION_LIST_FAIL:
      return {
        ...state,
      };
    case ITEM_ALLOCATION_LIST_REQUEST:
      return {
        ...state,
      };
    case ITEM_ALLOCATION_LIST_SUCCESS:
      return {
        ...state,
        itemAllocationList: action.payload,
      };

    case ITEM_ALLOCATION_LIST_FAIL:
      return {
        ...state,
      };
    case CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST:
      return {
        ...state,
        clearedAllocatedTransactionSuccessLoading: true,
      };
    case CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS:
      return {
        ...state,
        clearedAllocatedTransactionSuccess: action.payload,
        clearedAllocatedTransactionSuccessLoading: false,
      };
    case CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL:
      return {
        ...state,
        clearedAllocatedTransactionSuccessLoading: false,
      };
    case UNCLEAR_TRANSACTION_REQUEST:
      return {
        ...state,
      };
    case UNCLEAR_TRANSACTION_SUCCESS:
      return {
        ...state,
        unclearedTransactionSuccess: action.payload,
      };
    case UNCLEAR_TRANSACTION_FAIL:
      return {
        ...state,
      };
    case CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST:
      return {
        ...state,
        CustomerSearchALlTransactionsLoading: true,
      };

    case CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        singleCustomerSearchAllTransactions: action.payload,
        CustomerSearchALlTransactionsLoading: false,
      };
    case CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL:
      return {
        ...state,
        CustomerSearchALlTransactionsLoading: false,
      };
    case SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST:
      return {
        ...state,
        allBankTransactionListLoading: true,
      };

    case SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        singleSupplierSearchAllTransactions: action.payload,
        allBankTransactionListLoading: false,
      };
    case SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL:
      return {
        ...state,
        allBankTransactionListLoading: false,
      };
    case CREATE_SINGLE_BANK_TRANSACTION_REQUEST:
      return {
        ...state,
        createSingleBankTransactionSuccessLoading: true,
      };
    case CREATE_SINGLE_BANK_TRANSACTION_SUCCESS:
      return {
        ...state,
        createSingleBankTransactionSuccess: action.payload,
        createSingleBankTransactionSuccessLoading: false,
      };
    case CREATE_SINGLE_BANK_TRANSACTION_FAIL:
      return {
        ...state,
        createSingleBankTransactionSuccessLoading: false,
      };
    case BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST:
      return {
        ...state,
      };
    case BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS:
      return {
        ...state,
        singleCustomerTransactionPdfStatement: action.payload,
      };
    case BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL:
      return {
        ...state,
      };
    case BANK_UPLOAD_TRANSACTIONS_REQUEST:
      return {
        ...state,
        bankUploadTransactionsSuccessLoading: true,
      };
    case BANK_UPLOAD_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        bankUploadTransactionsSuccess: action.payload,
        bankUploadTransactionsSuccessLoading: false,
      };
    case BANK_UPLOAD_TRANSACTIONS_FAIL:
      return {
        ...state,
        bankUploadTransactionsSuccessLoading: false,
      };
    case BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
      };
    case BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        bankAssignedOnlyTransactionList: action.payload,
      };
    case BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL:
      return {
        ...state,
      };
    case BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST:
      return {
        ...state,
      };
    case BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS:
      return {
        ...state,
        bankAssignTransactionToCustomerSuccess: action.payload,
      };
    case BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL:
      return {
        ...state,
      };
    case BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST:
      return {
        ...state,
      };
    case BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS:
      return {
        ...state,
        bankUnassignTransactionFromCustomerSuccess: action.payload,
      };
    case BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL:
      return {
        ...state,
      };
    case CREATE_BANK:
      return {
        ...state,
      };
    case CREATE_BANK_SUCCESS:
      return {
        ...state,
        createBankSuccess: action.payload,
      };
    case CREATE_BANK_FAIL:
      return {
        ...state,
      };
    case UPDATE_BANK:
      return {
        ...state,
      };
    case UPDATE_BANK_SUCCESS:
      return {
        ...state,
        updateBankSuccess: action.payload,
      };
    case UPDATE_BANK_FAIL:
      return {
        ...state,
      };
    case DELETE_BANK:
      return {
        ...state,
      };
    case DELETE_BANK_SUCCESS:
      return {
        ...state,
        deleteBankSuccess: action.payload,
      };
    case DELETE_BANK_FAIL:
      return {
        ...state,
      };
    case SYNC_BANK_TRANSACTIONS:
      return {
        ...state,
        syncBankTransactionsData: {},
        syncBankTransactionsLoading: true,
      };
    case SYNC_BANK_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        syncBankTransactionsData: action.payload,
        syncBankTransactionsLoading: false,
      };
    case SYNC_BANK_TRANSACTIONS_FAIL:
      return {
        ...state,
        syncBankTransactionsData: action.payload,
        syncBankTransactionsLoading: false,
      };
    case SYNC_BANK_TRANSACTIONS_RESET:
      return {
        ...state,
        syncBankTransactionsData: {},
        syncBankTransactionsLoading: false,
      };
    case SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST:
      return {
        ...state,
      };
    case SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS:
      return {
        ...state,
        singleCustomerTransactionOpenItemsPdfStatement: action.payload,
      };
    case SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL:
      return {
        ...state,
      };
    case SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST:
      return {
        ...state,
      };
    case SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS:
      return {
        ...state,
        singleCustomerTransactionAllItemsPdfStatement: action.payload,
      };
    case SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL:
      return {
        ...state,
      };
    case GET_BANK_ACCOUNT_STATUS_LIST:
      return {
        ...state,
      };
    case GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        bankAccountStatusList: action.payload,
      };
    case GET_BANK_ACCOUNT_STATUS_LIST_FAIL:
      return {
        ...state,
      };
    case BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST:
      return {
        ...state,
      };
    case BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS:
      return {
        ...state,
        bankTransactionAllocationDeleteTransactionSuccess: action.payload,
      };
    case BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL:
      return {
        ...state,
        bankTransactionAllocationDeleteTransactionSuccess: action.payload,
      };
    case GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST:
      return { ...state };
    case GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS:
      return { ...state, manualBankTransactionDetails: action.payload };
    case GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL:
      return { ...state };
    case UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST:
      return {
        ...state,
        updateManualBankTransactionDetailsSuccessLoading: true,
      };
    case UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        updateManualBankTransactionDetailsSuccess: action.payload,
        updateManualBankTransactionDetailsSuccessLoading: false,
      };
    case UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL:
      return {
        ...state,
        updateManualBankTransactionDetailsSuccessLoading: false,
      };
    case BANK_ACCOUNT_PROVIDER_LIST_REQUEST:
      return { ...state, bankAccountProviderListLoading: true };
    case BANK_ACCOUNT_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        bankAccountProviderList: action.payload,
        bankAccountProviderListLoading: false,
      };
    case BANK_ACCOUNT_PROVIDER_LIST_FAIL:
      return { ...state, bankAccountProviderListLoading: false };
    case GET_BANK_ACCOUNT_STATUS_DATA_REQUEST:
      return { ...state, bankAccountStatusDataLoading: true };
    case GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        bankAccountStatusData: action.payload,
        bankAccountStatusDataLoading: false,
      };
    case GET_BANK_ACCOUNT_STATUS_DATA_FAIL:
      return { ...state, bankAccountStatusDataLoading: false };
    case CREATE_BANK_ACCOUNT_STATUS_REQUEST:
      return { ...state, createBankAccountStatusSuccessLoading: true };
    case CREATE_BANK_ACCOUNT_STATUS_SUCCESS:
      return {
        ...state,
        createBankAccountStatusSuccess: action.payload,
        createBankAccountStatusSuccessLoading: false,
      };
    case CREATE_BANK_ACCOUNT_STATUS_FAIL:
      return { ...state, createBankAccountStatusSuccessLoading: false };
    case UPDATE_BANK_ACCOUNT_STATUS_REQUEST:
      return { ...state, updateBankAccountStatusSuccessLoading: true };
    case UPDATE_BANK_ACCOUNT_STATUS_SUCCESS:
      return {
        ...state,
        updateBankAccountStatusSuccess: action.payload,
        updateBankAccountStatusSuccessLoading: false,
      };
    case UPDATE_BANK_ACCOUNT_STATUS_FAIL:
      return { ...state, updateBankAccountStatusSuccessLoading: false };
    case DELETE_BANK_ACCOUNT_STATUS_REQUEST:
      return { ...state, deleteBankAccountStatusSuccessLoading: true };
    case DELETE_BANK_ACCOUNT_STATUS_SUCCESS:
      return {
        ...state,
        deleteBankAccountStatusSuccess: action.payload,
        deleteBankAccountStatusSuccessLoading: false,
      };
    case DELETE_BANK_ACCOUNT_STATUS_FAIL:
      return { ...state, deleteBankAccountStatusSuccessLoading: false };
    case BANK_ACCOUNT_FEED_CONNECTION_REQUEST:
      return { ...state, bankAccountFeedConnectionSuccessLoading: true };
    case BANK_ACCOUNT_FEED_CONNECTION_SUCCESS:
      return {
        ...state,
        bankAccountFeedConnectionSuccess: action.payload,
        bankAccountFeedConnectionSuccessLoading: false,
      };
    case BANK_ACCOUNT_FEED_CONNECTION_FAIL:
      return { ...state, bankAccountFeedConnectionSuccessLoading: false };
    case BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST:
      return { ...state, bankAccountFeedMapAccountsSuccessLoading: true };
    case BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS:
      return {
        ...state,
        bankAccountFeedMapAccountsSuccess: action.payload,
        bankAccountFeedMapAccountsSuccessLoading: false,
      };
    case BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL:
      return { ...state, bankAccountFeedMapAccountsSuccessLoading: false };
    case BANK_TRANSACTION_IMPORT_REQUEST:
      return { ...state, bankTransactionImportSuccessLoading: true };
    case BANK_TRANSACTION_IMPORT_SUCCESS:
      return {
        ...state,
        bankTransactionImportSuccess: action.payload,
        bankTransactionImportSuccessLoading: false,
      };
    case BANK_TRANSACTION_IMPORT_FAIL:
      return { ...state, bankTransactionImportSuccessLoading: false };
    case BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST:
      return { ...state, bankTransactionAllocationUnclearLoading: true };

    case BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS:
      return {
        ...state,
        bankTransactionAllocationUnclearSuccess: action.payload,
        bankTransactionAllocationUnclearLoading: false,
      };
    case BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL:
      return {
        ...state,
        bankTransactionAllocationUnclearLoading: false,
        bankTransactionAllocationUnclearSuccess: action.payload,
      };
    case BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST:
      return { ...state, bankTransactionAllocationSplitLoading: true };

    case BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS:
      return {
        ...state,
        bankTransactionAllocationSplitSuccess: action.payload,
        bankTransactionAllocationSplitLoading: false,
      };
    case BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL:
      return {
        ...state,
        bankTransactionAllocationSplitLoading: false,
        bankTransactionAllocationSplitSuccess: action.payload,
      };
    case BANK_ACCOUNT_FEED_RECONNECTION_REQUEST:
      return { ...state, bankAccountFeedReconnectionSuccessLoading: true };
    case BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS:
      return {
        ...state,
        bankAccountFeedReconnectionSuccess: action.payload,
        bankAccountFeedReconnectionSuccessLoading: false,
      };
    case BANK_ACCOUNT_FEED_RECONNECTION_FAIL:
      return {
        ...state,
        bankAccountFeedReconnectionSuccessLoading: false,
        bankAccountFeedReconnectionSuccess: action.payload,
      };
    case CLEARING_DOCUMENT_SEARCH_REQUEST:
      return {
        ...state,
        clearingDocumentSearchLoading: true,
        clearingDocumentSearchError: null,
      };
    case CLEARING_DOCUMENT_SEARCH_SUCCESS:
      return {
        ...state,
        clearingDocumentSearchLoading: false,
        clearingDocumentSearchSuccess: action.payload,
        clearingDocumentSearchError: null,
      };
    case CLEARING_DOCUMENT_SEARCH_FAIL:
      return {
        ...state,
        clearingDocumentSearchLoading: false,
        clearingDocumentSearchSuccess: action.payload,
        clearingDocumentSearchError: null,
      };
    case BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST:
      return {
        ...state,
        bankTransactionAllocationAutoclearSuccessLoading: true,
      };
    case BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS:
      return {
        ...state,
        bankTransactionAllocationAutoclearSuccess: action.payload,
        bankTransactionAllocationAutoclearSuccessLoading: false,
      };
    case BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL:
      return {
        ...state,
        bankTransactionAllocationAutoclearSuccess: action.payload,
        bankTransactionAllocationAutoclearSuccessLoading: false,
      };

    // Bank Account Attachment (bank statements)
    case BANK_ACCOUNT_ATTACHMENT_SEARCH:
      return {
        ...state,
        bankAccountAttachmentListLoading: true,
        bankAccountAttachmentListError: null,
      };
    case BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS:
      return {
        ...state,
        bankAccountAttachmentList: action.payload,
        bankAccountAttachmentListLoading: false,
        bankAccountAttachmentListError: null,
      };
    case BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE:
      return {
        ...state,
        bankAccountAttachmentList: [],
        bankAccountAttachmentListLoading: false,
        bankAccountAttachmentListError: action.payload,
      };
    case BANK_ACCOUNT_ATTACHMENT_DELETE:
      return {
        ...state,
        bankAccountAttachmentDeleteLoading: true,
        bankAccountAttachmentDeleteError: null,
      };
    case BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS:
      return {
        ...state,
        bankAccountAttachmentDelete: action.payload,
        bankAccountAttachmentDeleteLoading: false,
        bankAccountAttachmentDeleteError: null,
      };
    case BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE:
      return {
        ...state,
        bankAccountAttachmentDelete: [],
        bankAccountAttachmentDeleteLoading: false,
        bankAccountAttachmentDeleteError: action.payload,
      };

    // Bank Account Statement (bank statements with a period)
    case BANK_ACCOUNT_STATEMENT_SEARCH:
      return {
        ...state,
        bankAccountStatementListLoading: true,
        bankAccountStatementListError: null,
      };
    case BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS:
      return {
        ...state,
        bankAccountStatementList: action.payload,
        bankAccountStatementListLoading: false,
        bankAccountStatementListError: null,
      };
    case BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE:
      return {
        ...state,
        bankAccountStatementList: [],
        bankAccountStatementListLoading: false,
        bankAccountStatementListError: action.payload,
      };
    case BANK_ACCOUNT_STATEMENT_DELETE:
      return {
        ...state,
        bankAccountStatementDeleteLoading: true,
        bankAccountStatementDeleteError: null,
      };
    case BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS:
      return {
        ...state,
        bankAccountStatementDelete: action.payload,
        bankAccountStatementDeleteLoading: false,
        bankAccountStatementDeleteError: null,
      };
    case BANK_ACCOUNT_STATEMENT_DELETE_FAILURE:
      return {
        ...state,
        bankAccountStatementDelete: [],
        bankAccountStatementDeleteLoading: false,
        bankAccountStatementDeleteError: action.payload,
      };

    default:
      return state;
  }
};

export default Bank;
